import { render, staticRenderFns } from "./EntitlementPage.vue?vue&type=template&id=4c22eb1e&scoped=true"
import script from "./EntitlementPage.vue?vue&type=script&lang=js"
export * from "./EntitlementPage.vue?vue&type=script&lang=js"
import style0 from "./EntitlementPage.vue?vue&type=style&index=0&id=4c22eb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22eb1e",
  null
  
)

export default component.exports